import { BuscadorPV } from '../models/buscadorPV';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IChangePassword } from '../interfaces/IChangePassword';
import { IConfirmEmail } from '../interfaces/IConfirmarEmail';
import { Injectable } from '@angular/core';
import { IUser } from '../interfaces/IUser';
import { PedidoVentaCabecera } from '../models/pedidoVentaCabecera';
import { Usuario } from '../models/usuario';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PVService {

  private pvServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.pvServerUri = this.apiUrl + '/' + this.configService.PVURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }
  linkpdf()
  {
    return this.httpCliente.get(this.pvServerUri);
  }
  aprobarPedidoVenta(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'AprobarPedidoVenta', pvc, { headers: this.getHeaders() });
  }

  aprobarPedidoVentaRetenido(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'AprobarPedidoVentaRetenido', pvc, { headers: this.getHeaders() });
  }

  rechazarPedidoVenta(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'RechazarPedidoVenta', pvc, { headers: this.getHeaders() });
  }

  rechazarPedidoVentaPorCliente(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'RechazarPedidoVentaPorCliente', pvc, { headers: this.getHeaders() });
  }

  amPedidoVenta(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'AMPedidoVenta', pvc, { headers: this.getHeaders() });
  }
  guardarNroOC(cab: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'GuardarNroOC', cab, { headers: this.getHeaders() });
  }
  aPedidoVentaItem(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'APedidoVentaItem', pvc, { headers: this.getHeaders() });
  }

  mPedidoVentaItem(pvc: PedidoVentaCabecera) {
    return this.httpCliente.post(this.pvServerUri + 'MPedidoVentaItem', pvc, { headers: this.getHeaders() });
  }

  bPedidoVentaItem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.pvServerUri + `BPedidoVentaItem?codigoCabecera=${codigoCabecera}&codigoItem=${codigoItem}`, { headers: this.getHeaders() });
  }

  cPedidosVenta(buscador: BuscadorPV) {
    return this.httpCliente.post(this.pvServerUri + 'CPedidosVenta', buscador, { headers: this.getHeaders() });
  }

  cPedidoVentaItem(nroClienteDistribuidor: string, idSucursal: string, codigoItem: number) {
    return this.httpCliente.get(this.pvServerUri + `CPedidoVentaItem?nroClienteDistribuidor=${nroClienteDistribuidor}&idSucursal=${idSucursal}&codigoItem=${codigoItem}`, { headers: this.getHeaders() });
  }

  cPedidoVenta(idPais: string, idCompania: string, idSalesOrg: string, idTipoOrden: string, codigo: number) {
    return this.httpCliente.get(this.pvServerUri + `CPedidoVenta?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&idTipoOrden=${idTipoOrden}&codigo=${codigo}`, { headers: this.getHeaders() });
  }

  cListasPreciosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, idFormaPago: string, idGrupoCliente: string, idTipoOrden: string, search: string) {
    nroCliente = nroCliente || "";
    idGrupoCliente = idGrupoCliente || "";
    return this.httpCliente.get(this.pvServerUri + `CListasPreciosAutocompleteSearch?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&nroCliente=${nroCliente}&idFormaPago=${idFormaPago}&idGrupoCliente=${idGrupoCliente}&idTipoOrden=${idTipoOrden}&search=${search}`, { headers: this.getHeaders() });
  }

  cListaPrecioItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string, idTerminoPago: string, idMoneda: string, search: string) {
    idMoneda = idMoneda || "";
    idTerminoPago = idTerminoPago || "";
    idTipoListaPrecios = idTipoListaPrecios || "";
    return this.httpCliente.get(this.pvServerUri + `CListaPrecioItemsAutocompleteSearch?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&idTipoListaPrecios=${idTipoListaPrecios}&idTerminoPago=${idTerminoPago}&idMoneda=${idMoneda}&search=${search}`, { headers: this.getHeaders() });
  }

  cTerminosPagoTipoListaPrecios(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string) {
    return this.httpCliente.get(this.pvServerUri + `CTerminosPagoTipoListaPrecios?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&idTipoListaPrecios=${idTipoListaPrecios}`, { headers: this.getHeaders() });
  }

  cStockDisponible(idPais: string, idCompania: string, idSalesOrg: string, idPlanta: string, nroCliente: string, nroClienteDireccion: string, idProducto: string) {
    return this.httpCliente.get(this.pvServerUri + `CStockDisponible?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&idPlanta=${idPlanta}&nroCliente=${nroCliente}&nroClienteDireccion=${nroClienteDireccion}&idProducto=${idProducto}`, { headers: this.getHeaders() });
  }

  cPedidoVentaRetenciones(idPais: string, idCompania: string, idSalesOrg: string, nroPedido: number) {
    return this.httpCliente.get(this.pvServerUri + `CPedidoVentaRetenciones?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&nroPedido=${nroPedido}`, { headers: this.getHeaders() });
  }

  cCuotasDistribuidores(idPais: string, idCompania: string, idSalesOrg: string, nroClienteDistribuidor: string, idSucursal: string, idProducto: string) {
    return this.httpCliente.get(this.pvServerUri + `cCuotasDistribuidores?idPais=${idPais}&idCompania=${idCompania}&idSalesOrg=${idSalesOrg}&nroClienteDistribuidor=${nroClienteDistribuidor}&idSucursal=${idSucursal}&idProducto=${idProducto}`, { headers: this.getHeaders() });
  }
  copiarPVA(codigo: number) {
    return this.httpCliente.get(this.pvServerUri + 'CopiarPVA?codigo=' + codigo, { headers: this.getHeaders() });
  }


}